import "firebase/compat/firestore";

import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";

// Initialize Firebase with your project's credentials
const firebaseConfig = {
  apiKey: "AIzaSyCnG54VQSJ_ZMd1BUFn7EwpWKRzXMwewWE",
  authDomain: "cheersron-cb77b.firebaseapp.com",
  projectId: "cheersron-cb77b",
  storageBucket: "cheersron-cb77b.appspot.com",
  messagingSenderId: "1017688505989",
  appId: "1:1017688505989:web:b7f612384e6ad3fab0b3ec",
};

// const app = initializeApp({
//   projectId: "### CLOUD FUNCTIONS PROJECT ID ###",
//   apiKey: "### FIREBASE API KEY ###",
//   authDomain: "### FIREBASE AUTH DOMAIN ###",
// });

const firebaseApp = initializeApp(firebaseConfig);
export const db = getFirestore(firebaseApp);

export default firebaseApp;
